import { LadiesMain } from "@modules/global/ladies-main.ts"
import { InfoPanel } from "@modules/info-panel/InfoPanel.ts"
import { openGenericModal } from "@modules/util/generic-modal.ts"

const purchaseState = LadiesMain._getHashtagObject()?.purchase_state
if (purchaseState === "success") {
    InfoPanel.displayMessage(
        "Beitrag erfolgreich freigeschaltet",
        InfoPanel.Type.Success,
        3 * 1000, // Millisekunden
    )
    LadiesMain.removeHashtagFromUrl("purchase_state")
}

if (purchaseState === "pending") {
    openGenericModal(
        "Vielen Dank! Dein Beitrag wird in Kürze bereitgestellt. Bitte habe noch einen Moment Geduld.",
        "Kauf erfolgreich!",
    )
    LadiesMain.removeHashtagFromUrl("purchase_state")
}
